import { useEffect, useState } from "react"

import SmallPopup from "../../../components/SmallPopup"
import Input from "../../../components/Input";
import { authAxios } from "../../../helpers/axios";

export default function CombineBlends({onClose,edit=false,onSubmit,data,id,submitting})
{
    const [manageData,setManageData] = useState({selectedToBlendId:'',selectedFromBlendId:''})
    const formName = 'combineBlends';

    

    return <><SmallPopup title={'Combine Blends' } submitting={submitting} submitTitle={'Combine'} onClose={onClose} formName={formName}>
        <form name={formName} onSubmit={(e)=>onSubmit(e,{selectedToBlendId:manageData?.selectedToBlendId,selectedFromBlendId:manageData?.selectedFromBlendId})} id={formName} className='grid grid-cols-2 gap-x-3 gap-y-0 w-full'>
            <div className="mb-4 col-span-2">
                <label>Select Blend to Minus From*</label>
                <select className="w-full" value={manageData?.selectedFromBlendId} onChange={(e)=>setManageData(prevData=>({...prevData,selectedFromBlendId:e.target.value}))}>
                    <option value={''}>Select Blend</option>
                    {data?.productionBlends?.map((item,index)=>
                    <option key={index} value={item?.id}>{item?.blendUsed?.batchNumber} - {item?.blendUsed?.blendName}</option>
                    )}
                </select>
            </div>
            <div className="mb-4 col-span-2">
                <label>Select Blend to Add To*</label>
                <select className="w-full" value={manageData?.selectedToBlendId} onChange={(e)=>setManageData(prevData=>({...prevData,selectedToBlendId:e.target.value}))}>
                    <option value={''}>Select Blend</option>
                    {data?.productionBlends?.map((item,index)=>
                    <option key={index} value={item?.id}>{item?.blendUsed?.batchNumber} - {item?.blendUsed?.blendName}</option>
                    )}
                </select>
            </div>
        </form>
    </SmallPopup>
    </>
}